var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 103,
    viewBox: "0 0 101 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100.844,
    height: 102.327,
    rx: 50.4219,
    fill: "white",
    fillOpacity: 0.48
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.479352,
    y: 0.479352,
    width: 99.885,
    height: 101.368,
    rx: 49.9425,
    stroke: "white",
    strokeOpacity: 0.72,
    strokeWidth: 0.958705
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4358 35.0093C43.9646 30.5354 50.1463 30.3999 51.9589 34.6028L52.1123 35.0119L54.1754 41.0453C54.6482 42.429 55.4123 43.6952 56.4161 44.7585C57.4198 45.8218 58.6399 46.6575 59.9941 47.2091L60.5489 47.4162L66.5823 49.4768C71.0563 51.0056 71.1918 57.1873 66.9914 58.9999L66.5823 59.1533L60.5489 61.2165C59.1647 61.689 57.898 62.4529 56.8343 63.4567C55.7705 64.4604 54.9345 65.6807 54.3825 67.0352L54.1754 67.5874L52.1148 73.6234C50.586 78.0973 44.4043 78.2328 42.5943 74.0324L42.4358 73.6234L40.3752 67.5899C39.9027 66.2058 39.1388 64.9391 38.135 63.8753C37.1312 62.8116 35.9109 61.9755 34.5565 61.4235L34.0043 61.2165L27.9708 59.1559C23.4943 57.6271 23.3588 51.4453 27.5618 49.6353L27.9708 49.4768L34.0043 47.4162C35.388 46.9434 36.6542 46.1794 37.7175 45.1756C38.7808 44.1718 39.6164 42.9517 40.1681 41.5975L40.3752 41.0453L42.4358 35.0093ZM47.2753 36.6608L45.2147 42.6943C44.4948 44.8042 43.3236 46.7318 41.7827 48.343C40.2417 49.9541 38.3682 51.2099 36.2924 52.0231L35.6532 52.2558L29.6198 54.3163L35.6532 56.3769C37.7632 57.0969 39.6908 58.2681 41.3019 59.809C42.913 61.3499 44.1689 63.2235 44.9821 65.2993L45.2147 65.9384L47.2753 71.9719L49.3359 65.9384C50.0558 63.8285 51.227 61.9008 52.768 60.2897C54.3089 58.6786 56.1824 57.4227 58.2582 56.6096L58.8974 56.3795L64.9308 54.3163L58.8974 52.2558C56.7874 51.5358 54.8598 50.3646 53.2487 48.8237C51.6376 47.2828 50.3817 45.4092 49.5685 43.3334L49.3384 42.6943L47.2753 36.6608ZM67.7277 26.1943C68.2059 26.1943 68.6746 26.3285 69.0805 26.5816C69.4863 26.8347 69.813 27.1965 70.0234 27.626L70.1462 27.9251L71.041 30.5481L73.6665 31.4429C74.1458 31.6058 74.566 31.9072 74.8738 32.3091C75.1816 32.711 75.3632 33.1952 75.3955 33.7004C75.4278 34.2056 75.3094 34.709 75.0553 35.1468C74.8012 35.5846 74.4229 35.9372 73.9682 36.1598L73.6665 36.2825L71.0435 37.1773L70.1487 39.8028C69.9856 40.282 69.6839 40.702 69.2819 41.0095C68.8798 41.317 68.3955 41.4983 67.8904 41.5303C67.3852 41.5624 66.8819 41.4437 66.4442 41.1894C66.0066 40.9352 65.6542 40.5567 65.4319 40.1019L65.3092 39.8028L64.4144 37.1798L61.7888 36.285C61.3095 36.1222 60.8893 35.8207 60.5815 35.4188C60.2738 35.0169 60.0922 34.5327 60.0599 34.0275C60.0276 33.5224 60.146 33.019 60.4001 32.5811C60.6541 32.1433 61.0325 31.7908 61.4871 31.5682L61.7888 31.4455L64.4118 30.5507L65.3066 27.9251C65.479 27.42 65.8052 26.9815 66.2393 26.6711C66.6735 26.3607 67.194 26.194 67.7277 26.1943Z",
    fill: "url(#paint0_linear_58_14466)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_14466",
    x1: 4.79494,
    y1: 29.7221,
    x2: 49.8541,
    y2: 70.9464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLogo);
export default __webpack_public_path__ + "static/media/AiLogo.bf535d5882a04a716d3647b529a474d9.svg";
export { ForwardRef as ReactComponent };